/*
 * sidebar (context)
 */
import { createContext, useContext } from "react"

type SheetSidebarContextType = {
	isInSheet: boolean
	closeSheet?: () => void
}
export const SheetSidebarContext = createContext<SheetSidebarContextType>({
	isInSheet: false,
})

export const useIsInSheetSidebar = () =>
	useContext(SheetSidebarContext).isInSheet
export const useSheetClose = () => useContext(SheetSidebarContext).closeSheet
